import CustomStore from "devextreme/data/custom_store";
import { DataSource } from "devextreme/common/data";
import { getLoadOptionsParams } from "../../utils/loadOptionsParams";
import axios from "axios";
import store from "..";

const remoteDataSource = (additionalFilter) => {
  return new CustomStore({
    key: "id",
    load: async (loadOptions) => {
      return await axios
        .get(`/api/users/get` + getLoadOptionsParams(loadOptions), {
          params: additionalFilter,
        })
        .then((response) => {
          return {
            data: response.data.data,
            totalCount: response.data.totalCount,
            summary: response.data.summary,
          };
        })
        .catch((error) => {
          let errorMessage =
            error.response && error.response.data
              ? error.response.data
              : error.message;
          throw new Error(errorMessage);
        });
    },
  });
};

const createCardViewDataSource = (filter) => {
  var urlParams = new URLSearchParams(window.location.search);
  return new CustomStore({
    key: "id",
    load: async (loadOptions) => {
      return await axios
        .get(`/api/scheme/get` + getLoadOptionsParams(loadOptions), {
          params: {
            schemeId: filter.parentSchemeId,
            timeScope: filter.timeScope,
            translateCalls: filter.translateScheme,
            terms: urlParams.get("t"),
          },
        })
        .then((response) => {
          return {
            data: response.data.data,
            totalCount: response.data.totalCount,
            summary: response.data.summary,
          };
        })
        .catch((error) => {
          let errorMessage =
            error.response && error.response.data
              ? error.response.data
              : error.message;
          throw new Error(errorMessage);
        });
    },
  });
};

const getVisibleMessages = () => store.getters["chat/visibleMessages"] ?? [];
const getChatMessageById = (id) =>
  getVisibleMessages().find((message) => message.id === id) ?? null;

const chatCustomStore = new CustomStore({
  key: "id",
  load: () => Promise.resolve(getVisibleMessages()),
  byKey: (id) => Promise.resolve(getChatMessageById(id)),
  insert: (message) => Promise.resolve(message),
  update: (key, values) =>
    Promise.resolve({
      ...getChatMessageById(key),
      ...values,
    }),
});

const chatDataSource = new DataSource({
  store: chatCustomStore,
  paginate: false,
});

const syncChatDataSource = (changes) => {
  if (!Array.isArray(changes) || !changes.length) return;

  chatDataSource.store().push(changes);
};

const reloadChatDataSource = () => chatDataSource.reload();

export {
  createCardViewDataSource,
  remoteDataSource,
  chatDataSource,
  syncChatDataSource,
  reloadChatDataSource,
};
